// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Axbno","inputWrap":"styles_inputWrap__3DK6F","input":"styles_input__1LaOh"};